import React from 'react';
import { css } from '@emotion/core';
import TwitterIcon from '@material-ui/icons/Twitter';
import ShareIconButton from '../ShareIconButton';

const TwitterShareButton = ({ url }) => {
    return (
        <ShareIconButton
            variant="contained"
            text="Twitter"
            bgColor="#1da1f2"
            icon={TwitterIcon}
            url={`https://twitter.com/intent/tweet?text=${encodeURIComponent(url)}`}
            size={28}
            style={twitterButtonStyle}
        />
    );
};

export default TwitterShareButton;

const twitterButtonStyle = css`
    color: #ffffff;
    padding: 10px;
`;
